import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext.tsx';
import Routes from '@/router/Routes.ts';
import Middleware from '@/router/middleware/index.tsx';
import OnboardingStep from '$/_const/OnboardingStep.ts';

const OnboardingNotFinished: FC = () => {
  const { user, isLoading } = useAuthContext();

  const isOnboardingFinished = user?.onboarding_step === OnboardingStep.FINISHED;

  return (
    <Middleware isLoading={isLoading}>{isOnboardingFinished ? <Navigate to={Routes.DASHBOARD} /> : <Outlet />}</Middleware>
  );
};

export default OnboardingNotFinished;

